<template>
  <div v-if="show" class="mediaPreview-container">
    <div class="mediaPreview-content">
      <i @click="close" class="close"></i>
      <p :title="info.title" class="title">{{info.title}}</p>
      <div class="content">
        <div class="left">
          <video controls controlsList="nodownload" ref="video" :src="info.video_url"></video>
          <div class="speedRate">
            <div @click="showSelectList=!showSelectList" class="btn">
              <span>{{nowSpeed}}</span>
              <img src="./assets/whiteArrow.svg" alt="">
            </div>
            <div v-if="showSelectList" class="btnList">
              <p></p>
              <ul>
                <li @click="changeSpeed('1x')">1x</li>
                <li @click="changeSpeed('2x')">2x</li>
                <li @click="changeSpeed('4x')">4x</li>
              </ul>
            </div>
          </div>
          <div v-if="!info.noVideoBtn" @click="toMaterial(info.video_url)" class="toMaterial">
              <i></i>
              <span>我的素材</span>
          </div>
        </div>
        <div class="right">
          <p class="title">详情</p>
          <ul>
            <li class="tag">
              <i></i>
              <span>{{info.client_name}}</span>
            </li>
            <li class="upload">
              <i></i>
              <span>{{info.type}}</span>
            </li>
            <li class="user">
              <i></i>
              <span>{{info.author}}</span>
            </li>
            <li class="time">
              <i></i>
              <span>{{info.raw_add_time}}</span>
            </li>
          </ul>
          <ul>
            <li class="zan">
              <i></i>
              <span>点赞数：{{info.like_num}}</span>
            </li>
            <li class="comment">
              <i></i>
              <span>评论数：{{info.comment_num}}</span>
            </li>
            <li class="share">
              <i></i>
              <span>转发数：{{info.share_num}}</span>
            </li>
            <li v-if="info.emotion" class="emotion">
              <i></i>
              <p :class="{high: info.emotion == '正面', normal: info.emotion == '中性', low: info.emotion == '负面'}">{{info.emotion}}</p>
            </li>
          </ul>
          <div v-if="info.url" class="btns">
            <p @click="navigate(info.url)" class="check">
              <i></i>
              <span>查看原文</span>
            </p>
            <!-- <p class="download">
              <i></i>
              <span>下载</span>
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
  data() {
    return {
      show: false,
      nowSpeed: "1x",
      showSelectList: false,
      info: {

      }
    }
  },
  methods: {
    toMaterial(url) {
      let info = {
        url: url,
        title: this.info.title
      }

      common.myFetch(apis.browserdownload, info).then((res) => {
        if(res){
          this.$toast(res)
        }
        // console.log(res)
      })
    },
    navigate(url) {
      common.jumpOut(url)
    },
    open(config) {
      this.info = config
      this.show = true

      this.$nextTick(() => {
        this.disableContextMenu()
      })
    },
    disableContextMenu() {
      // 隐藏右键菜单
      if(this.$refs.video){
        this.$refs.video.oncontextmenu = function(event) {
          return false
        }
      }
    },
    close() {
      this.show = false
    },
    changeSpeed(speed) {
      this.nowSpeed = speed;
      let multiple = 1;
      if (speed === "1x") {
        multiple = 1;
      } else if (speed === "2x") {
        multiple = 2;
      } else {
        multiple = 4;
      }
      this.$refs.video.playbackRate = multiple;
      this.showSelectList = false;
    }
  }
}
</script>

<style lang="less" scoped>
  .mediaPreview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(50, 59, 75, 0.3); 
    backdrop-filter: blur(1.6px);

    .toMaterial {
      position: absolute;
      top: 14px;
      left: 14px;
      z-index: 99;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 104px;
        height: 30px;
        background: rgba(65, 180, 140, 0.7);
        border-radius: 15px;
        user-select: none;
        cursor: pointer;

      i {
          display: block;
          width: 16px;
          height: 16px;
          background: url('./assets/send.png') no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          margin-right: 6px;
      }

      span {
          font-size: 14px;
          line-height: 20px;
          color: #FFFFFF;
          font-weight: 800;
      }
    }

    .mediaPreview-content {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 1020px;
      min-height: 479px;
      background: #F9F9F9;
      box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
      padding: 22px 30px 40px;
      border-radius: 4px;
      box-sizing: border-box;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        display: block;
        width: 20px;
        height: 20px;
        background: url('./assets/delIcon.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        user-select: none;
        cursor: pointer;
      }

      &>.title {
        font-size: 22px;
        line-height: 30px;
        color: #050F0F;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 21px;
      }

      &>.content {
        display: flex;
        flex-direction: row;
        width: 100%;
        min-height: 366px;

        .left {
          position: relative;
          width: 650px;
          height: 366px;
          margin-right: 30px;

          video {
            width: 100%;
            height: 100%;
          }

          .speedRate {
            position: absolute;
            top: 14px;
            right: 14px;

            .btn {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 62px;
              height: 30px;
              border-radius: 15px;
              background: rgba(0, 0, 0, 0.3);
              user-select: none;
              cursor: pointer;

              span {
                display: block;
                font-size: 16px;
                line-height: 30px;
                color: #fff;
              }

              img {
                margin-left: 4px;
              }
            }

            .btnList {
              display: flex;
              flex-direction: column;

              p {
                height: 10px;
              }

              ul {
                display: flex;
                flex-direction: column;
                border-radius: 4px;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.3);

                li {
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  user-select: none;
                  cursor: pointer;

                  &:hover {
                    background: rgba(0, 0, 0, 0.5);
                  }
                }
              }
            }
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          flex: 1;
          height: 100%;

          &>.title {
            font-size: 16px;
            line-height: 22px;
            color: #050F0F;
            font-weight: bold;
            margin-bottom: 14px;
          }

          ul {
            display: flex;
            flex-direction: column;
            padding-top: 14px;
            border-top: 1px solid #EEEEEE;
            box-sizing: border-box;

            li {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-bottom: 14px;

              &.tag {
                i {
                  background: url('./assets/tag.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.upload {
                i {
                  background: url('./assets/upload.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.user {
                i {
                  background: url('./assets/user.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }
              &.time {
                i {
                  background: url('./assets/time.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.zan {
                i {
                  background: url('./assets/zan.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.comment {
                i {
                  background: url('./assets/comment.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.share {
                i {
                  background: url('./assets/share.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }
              }

              &.emotion {
                display: flex;
                align-items: center;
                i {
                  background: url('./assets/emotion.png') no-repeat;
                  background-position: center center;
                  background-size: 100% 100%;
                }

                p{
                  font-size: 13px;
                  color: #323B4B;
                  padding: 0 14px;
                  height: 24px;
                  line-height: 24px;
                  box-sizing: border-box;
                  background: rgba(185,195,195,0.2);
                  border-radius: 4px;
                  // margin: 0 10px 10px 0;

                  &.high {
                      background: rgba(113, 158, 248, 0.1);
                      border: 1px solid #719EF8;
                      color: #719EF8;
                      box-sizing: border-box;
                  }

                  &.normal {
                      background: rgba(113,220,177,0.1000);
                      border: 1px solid #71DCB1;
                      color: #71DCB1;
                      box-sizing: border-box;
                  }

                  &.low {
                      background: rgba(233,124,99,0.1000);
                      border: 1px solid #E97C63;
                      color: #E97C63;
                      box-sizing: border-box;
                  }
                }
              }

              i {
                display: block;
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }

              span {
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: 500;
              }
            }
          }
        }
      }

      .btns {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 24px;
        user-select: none;
        cursor: pointer;

        .check {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 200px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #41B48C;

          i {
            display: block;
            width: 20px;
            height: 20px;
            background: url('./assets/link.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            line-height: 20px;
            color: #41B48C;
          }
        }

        .download {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #41B48C;
          margin-left: 10px;

          i {
            display: block;
            width: 20px;
            height: 20px;
            background: url('./assets/download.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            line-height: 20px;
            color: #41B48C;
          }
        }
      }
    }
  }
</style>